<template>
  <div>
    <div
        class="myFinance-widget"
        data-campaign="homegauge-ac"
        data-widget-id="ebefcaf3-016c-4d1e-9d09-1cd446446b3e"
        :data-zip="postalCode"
        ref="myFiAd">
    </div>
    </div>
</template>
<script>
export default {
  name: 'AllConnect',
  props: {
  },
  data() {
    return {
      postalCode: null,
    };
  },
  async mounted() {
    await this.loadAllConnectWidget();
    await this.retrieveInspections();
    this.retrieveAllConnectWidget();
  },
  methods: {
    loadAllConnectWidget() {
      const script = document.createElement('script');
      script.src = 'https://static.myfinance.com/widget/myFinance.js';
      document.head.appendChild(script);
    },
    async retrieveInspections() {
      const { currentUser } = this.$store.state.User;
      const InspectionsResponse = await this.$store.dispatch('Inspection/loadInspections', currentUser.legacyId);
      if (InspectionsResponse && InspectionsResponse.folders
        && InspectionsResponse.folders.length > 0) {
        this.postalCode = InspectionsResponse.folders[0].postalCode;
      }
    },
    retrieveAllConnectWidget() {
      if (window.mfEmbed && window.requestMyFinanceAds) {
        window.requestMyFinanceAds({
          rootElement: this.$refs.myFiAd,
          skipDynamicAds: true,
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>

</style>
